export const sideAnalyticsIcon = (size: number) => (
	<svg width={size} height={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M13 0C5.83203 0 0 5.83203 0 13C0 20.168 5.83203 26 13 26C20.168 26 26 20.168 26 13C26 5.83203 20.168 0 13 0ZM11.875 2.0625C11.918 2.05859 11.957 2.06641 12 2.0625V13.4062L12.2812 13.7188L20.0625 21.4688C18.1562 23.0625 15.6875 24 13 24C6.91406 24 2 19.0859 2 13C2 7.29297 6.32031 2.625 11.875 2.0625ZM14 2.0625C19.2852 2.53906 23.4609 6.71484 23.9375 12H14V2.0625ZM15.4375 14H23.9375C23.7305 16.293 22.8633 18.3945 21.4688 20.0625L15.4375 14Z"
			fill="black"
		/>
	</svg>
);
